import React from "react";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';

const LicenseExpiryTracker = () => {
  return ( <div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
    <div className="">
      <div className="flex items-center justify-between mb-6">

        <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="Timer" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">License Expiry & Renewal Tracker</h1>
                <p className="text-muted mb-0 small">Monitor upcoming expirations, renewals, and option periods</p>
              </div>
</div>

        {/* <div>
          <h1 className="text-3xl font-bold text-gray-900">License Expiry & Renewal Tracker</h1>
          <p className="text-gray-500 mt-1">Monitor upcoming expirations, renewals, and option periods</p>
        </div> */}
        <div className="flex gap-2">
          <button className="border px-4 py-2 rounded-lg bg-white hover:bg-gray-50">Set Alert Rules</button>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">Export Calendar</button>
        </div>
      </div>

      {/* Alert Banner */}
      <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 flex items-center gap-3">
        <div className="bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold">!</div>
        <div>
          <p className="font-semibold text-red-800">3 licenses expiring within 30 days</p>
          <p className="text-sm text-red-600">Immediate action required for renewal negotiations</p>
        </div>
        <button className="ml-auto bg-red-600 text-white px-3 py-1 rounded-lg text-sm">View All</button>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-5 gap-4 mb-6">
        <div className="bg-white rounded-xl shadow p-2 text-center">
          <p className="text-3xl font-bold text-gray-900">24</p>
          <p className="text-sm text-gray-500">Active Licenses</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 text-center border-2 border-red-300">
          <p className="text-3xl font-bold text-red-600">3</p>
          <p className="text-sm text-gray-500">Expiring in 30 days</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 text-center border-2 border-orange-300">
          <p className="text-3xl font-bold text-orange-600">5</p>
          <p className="text-sm text-gray-500">Expiring in 90 days</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 text-center border-2 border-yellow-300">
          <p className="text-3xl font-bold text-yellow-600">4</p>
          <p className="text-sm text-gray-500">Auto-Renewal Pending</p>
        </div>
        <div className="bg-white rounded-xl shadow p-2 text-center">
          <p className="text-3xl font-bold text-green-600">7</p>
          <p className="text-sm text-gray-500">Recently Renewed</p>
        </div>
      </div>

      {/* Timeline */}
      <div className="bg-white rounded-xl shadow p-6 mb-6">
        <h5 className="text-lg font-semibold mb-4">Expiry Timeline</h5>
        <div className="relative">
          <div className="absolute left-0 right-0 h-2 bg-gray-200 rounded-full top-6"></div>
          <div className="flex justify-between relative">
            <div className="text-center z-10">
              <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center text-white font-bold mx-auto">3</div>
              <p className="text-xs font-semibold mt-2">Apr 2026</p>
              <p className="text-xs text-red-600">30 days</p>
            </div>
            <div className="text-center z-10">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mx-auto">5</div>
              <p className="text-xs font-semibold mt-2">May-Jun 2026</p>
              <p className="text-xs text-orange-600">60-90 days</p>
            </div>
            <div className="text-center z-10">
              <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center text-white font-bold mx-auto">4</div>
              <p className="text-xs font-semibold mt-2">Jul-Sep 2026</p>
              <p className="text-xs text-yellow-600">90-180 days</p>
            </div>
            <div className="text-center z-10">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center text-white font-bold mx-auto">8</div>
              <p className="text-xs font-semibold mt-2">Oct-Dec 2026</p>
              <p className="text-xs text-green-600">180+ days</p>
            </div>
            <div className="text-center z-10">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold mx-auto">4</div>
              <p className="text-xs font-semibold mt-2">2027+</p>
              <p className="text-xs text-blue-600">Long-term</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contract List */}
      <div className="bg-white rounded-xl shadow p-6">
        <h5 className="text-lg font-semibold mb-4">Upcoming Expirations</h5>
        <div className="space-y-3">
          <div className="flex items-center gap-4 p-4 border border-red-200 rounded-lg bg-red-50">
            <div className="bg-red-500 text-white px-3 py-1 rounded text-sm font-mono">7 days</div>
            <div className="flex-1">
              <p className="font-semibold">Pacific Coast Toys — StarBlaze Heroes</p>
              <p className="text-sm text-gray-500">Expires: Apr 5, 2026 | Min Guarantee: $45,000 | Territory: US West Coast</p>
            </div>
            <div className="flex gap-2">
              <button className="bg-green-600 text-white px-3 py-1 rounded text-sm">Renew</button>
              <button className="border px-3 py-1 rounded text-sm">View</button>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 border border-red-200 rounded-lg bg-red-50">
            <div className="bg-red-500 text-white px-3 py-1 rounded text-sm font-mono">14 days</div>
            <div className="flex-1">
              <p className="font-semibold">NovaTech Games — Midnight Echo</p>
              <p className="text-sm text-gray-500">Expires: Apr 12, 2026 | Min Guarantee: $25,000 | Territory: North America</p>
            </div>
            <div className="flex gap-2">
              <button className="bg-green-600 text-white px-3 py-1 rounded text-sm">Renew</button>
              <button className="border px-3 py-1 rounded text-sm">View</button>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 border border-red-200 rounded-lg bg-red-50">
            <div className="bg-red-500 text-white px-3 py-1 rounded text-sm font-mono">28 days</div>
            <div className="flex-1">
              <p className="font-semibold">Bright Star Retail — Aurora Animation</p>
              <p className="text-sm text-gray-500">Expires: Apr 26, 2026 | Min Guarantee: $60,000 | Territory: EU + UK</p>
            </div>
            <div className="flex gap-2">
              <button className="bg-green-600 text-white px-3 py-1 rounded text-sm">Renew</button>
              <button className="border px-3 py-1 rounded text-sm">View</button>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 border border-orange-200 rounded-lg">
            <div className="bg-orange-500 text-white px-3 py-1 rounded text-sm font-mono">45 days</div>
            <div className="flex-1">
              <p className="font-semibold">Golden State Apparel — Aurora Animation</p>
              <p className="text-sm text-gray-500">Expires: May 13, 2026 | Auto-Renewal: Yes (30-day opt-out window) | Territory: US</p>
            </div>
            <div className="flex gap-2">
              <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded text-sm">Auto-Renew</span>
              <button className="border px-3 py-1 rounded text-sm">View</button>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 border border-orange-200 rounded-lg">
            <div className="bg-orange-500 text-white px-3 py-1 rounded text-sm font-mono">62 days</div>
            <div className="flex-1">
              <p className="font-semibold">Dreamlight Studios — StarBlaze Heroes</p>
              <p className="text-sm text-gray-500">Expires: May 30, 2026 | Option Period: 2-year extension available | Territory: Global</p>
            </div>
            <div className="flex gap-2">
              <button className="bg-purple-600 text-white px-3 py-1 rounded text-sm">Exercise Option</button>
              <button className="border px-3 py-1 rounded text-sm">View</button>
            </div>
          </div>
        </div>
      </div>
    </div></div></div></div></div>
  );
};

export default LicenseExpiryTracker;
